module.exports = __webpack_public_path__ + "static/media/mobileScreenshot03.2c1bc698.jpg";